import { render, staticRenderFns } from "./widget-table.vue?vue&type=template&id=c4136672&scoped=true&"
import script from "./widget-table.ts?vue&type=script&lang=ts&"
export * from "./widget-table.ts?vue&type=script&lang=ts&"
import style0 from "./widget-table.scss?vue&type=style&index=0&id=c4136672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4136672",
  null
  
)

export default component.exports